import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Skeleton,
  Typography,
} from "@mui/material";
import BreadCrumbs from "../../components/Breadcrumbs";
import Basket from "../../components/Basket/Basket";
import { paymentMethods } from "./PaymentMethods/paymentMethods";
import { useEffect, useState, useRef, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setStudent, openModal } from "../../redux/actions/actions";
import PayrIframeModal from "./PaymentMethods/payr/PayrIframeModal";
import dayjs from "dayjs";
import StyledTitleDot from "../../components/common/StyledTitleDot";
import axiosInstance from "../../axiosInstance";
import SelectStudent from "./SelectStudent/SelectStudent";
import TransferMate from "./PaymentMethods/transfermate/TransferMate";
import BankTransfer from "./PaymentMethods/bank_transfer/BankTransfer";
import PayrPayment from "./PaymentMethods/payr/PayrPayment";
import Swal from "sweetalert2";
import { getCheckoutTotalWithFee } from "../../common/utils";
import { useTranslation } from "react-i18next";

export default function Payment({ paymentType }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const student = useSelector((state) => state.student.student);
  const [students, setStudents] = useState([]);
  const dispatch = useDispatch();
  const [selectedStudent, setSelectedStudent] = useState({});
  const [paySnack, setPaySnack] = useState(false);
  const [loadingBasket, setLoadingBasket] = useState(false);
  const [postPaymentDetails, setPostPaymentDetails] = useState(null);
  const [paymentTypeServices, setPaymentTypeServices] = useState(null);

  const [countryCode, setCountryCode] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [payerDocument, setPayerDocument] = useState(null);
  const [state, setState] = useState(null);
  const [chineseName, setChineseName] = useState(null);
  const [indiaSourceOfFund, setIndiaSourceOfFund] = useState(null);
  const [indiaDeclarationAmt, setIndiaDeclarationAmt] = useState("");
  const [countriesInit, setCountriesInit] = useState(null);
  const [identificationControl, setIdentificationControl] = useState(false);
  const [stateCodeControl, setStateCodeControl] = useState(false);
  const [chineseNameControl, setChineseNameControl] = useState(false);
  const [totalPrice, setTotalPrice] = useState(null);
  const [hasOpenedRedirect, setHasOpenedRedirect] = useState(false);
  const redirectWindowRef = useRef(null);
  const [payrEnabled, setPayrEnabled] = useState(false);
  // const { data: countriesInit } = useSwr(API.TransferMate.Countries.Get.api);

  const displayPaymentMethods = useMemo(
    () =>
      payrEnabled
        ? paymentMethods
        : paymentMethods.filter((pm) => pm.name !== "payr"),
    [payrEnabled]
  );

  const getCountriesInit = async () => {
    let url = `${process.env.REACT_APP_BASE_URL}payment/transfermate/countries`;
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");

    if (!countriesInit) {
      try {
        const response = await axiosInstance.get(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
            XRefreshToken: `${token}`, // Bearer token burada ekleniyor
            "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
          },
        });

        setCountriesInit(response.data);
      } catch (error) {
        console.error("API isteği sırasında hata oluştu:", error);
      }
    }
  };

  useEffect(() => {
    getCountriesInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const token = localStorage.getItem("loginUser");
    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}payment/integration-flags`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          XRefreshToken: `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => setPayrEnabled(Boolean(res.data?.payr_enabled)))
      .catch(() => setPayrEnabled(false));
  }, []);
  const params = useParams();
  const invoiceId = paymentType === "invoice" ? params.invoiceId : null;
  const bookingId = paymentType === "booking" ? params.bookingId : null;
  const cartAdditionalServices = useSelector((state) =>
    paymentType === "shop"
      ? state.cart?.products?.cart
      : state.cart?.services?.cart
  );

  const navigate = useNavigate();
  // const handleStudent = (event) => {
  //   setSelectedStudent(event.target.value);
  // };

  console.log(student, "student here");
  const handleStudent = (event, newValue) => {
    if (newValue) {
      setSelectedStudent(newValue);
    } else {
      // Kullanıcı "x" ikonuna basarak seçimi temizlediğinde burası çalışacak
      dispatch(setStudent({}));
    }
  };

  // useEffect(() => {
  //   console.log(selectedStudent, "selected student");
  //   console.log(invoiceId, "selected student");
  //   console.log(bookingId, "selected student");
  //   if (!invoiceId && !bookingId && !Object.keys(selectedStudent).length) {
  //     console.log('hereee');
  //     setPostPaymentDetails(null);
  //   }
  // }, [selectedStudent, invoiceId, bookingId]);

  const location = useLocation(); // useLocation hook'unu kullanın
  const { paymentIds, postPaymentBookingDetails, postPaymentAirportTransfer } =
    location.state || {}; // paymentIds'i state'ten çıkarın

  useEffect(() => {
    if (Object.keys(selectedStudent).length) {
      dispatch(setStudent(selectedStudent));
    } else {
      //dispatch(setStudent({}));
      // console.log(selectedStudent, "dispatch(setStudent({})");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStudent]);

  const getStudents = async () => {
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}auth/students`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
            XRefreshToken: `${token}`, // Bearer token burada ekleniyor
            "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
          },
        }
      );
      setStudents(response?.data?.student);
    } catch (error) {
      console.error("Hata oluştu!", error);
      return [];
    }
  };

  // useEffect(() => {
  //   console.log(cartAdditionalServices, "cartAdditionalServices");
  // }, [cartAdditionalServices]);

  const initialPaymentMethod = displayPaymentMethods.find((paymentMethod) => {
    return paymentMethod.name === "transfermate";
  });
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState(initialPaymentMethod);
  const [cartItems, setCartItems] = useState([]);
  /** Cart fingerprint — must match the invoice's services to reuse a temp invoice (service checkout). */
  const cartItemsSignature = useMemo(
    () =>
      JSON.stringify(
        cartItems.map((item) => ({
          service_id: item.service_id,
          quantity: item.quantity,
          date: item.serviceDate,
          size: item.selectedSize,
        }))
      ),
    [cartItems]
  );
  /** Cart snapshot for which postPaymentDetails.invoice_id is valid (shop/services only). */
  const [shopInvoiceCartSig, setShopInvoiceCartSig] = useState(null);

  useEffect(() => {
    if (
      !paymentTypeServices ||
      postPaymentDetails?.invoice_id == null ||
      postPaymentDetails?.invoice_id === undefined
    ) {
      return;
    }
    setShopInvoiceCartSig(cartItemsSignature);
    // Snapshot cart whenever checkout returns a temp invoice id (shop flow).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postPaymentDetails?.invoice_id, paymentTypeServices]);

  /** Payer / regulatory fields only (no TransferMate payment method yet). */
  const transferMatePayerFieldsComplete = useMemo(() => {
    if (selectedPaymentMethod?.name !== "transfermate") return false;
    if (!countryCode) return false;
    if (identificationControl && !payerDocument) return false;
    if (stateCodeControl && !state) return false;
    if (chineseNameControl && !chineseName) return false;
    if (countryCode === "IN") {
      const pan = String(payerDocument || "").trim().toUpperCase();
      if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) return false;
      if (!indiaSourceOfFund || !String(indiaDeclarationAmt || "").trim()) {
        return false;
      }
    }
    return true;
  }, [
    selectedPaymentMethod?.name,
    countryCode,
    identificationControl,
    payerDocument,
    stateCodeControl,
    state,
    chineseNameControl,
    chineseName,
    indiaSourceOfFund,
    indiaDeclarationAmt,
  ]);

  /** Country needs document / state / Chinese name before showing TM payment options. */
  const needsTmExtraPayerFields = useMemo(() => {
    if (selectedPaymentMethod?.name !== "transfermate") return false;
    if (countryCode === "IN") return true;
    return identificationControl || stateCodeControl || chineseNameControl;
  }, [
    selectedPaymentMethod?.name,
    countryCode,
    identificationControl,
    stateCodeControl,
    chineseNameControl,
  ]);

  const lastShopAutoCheckoutSig = useRef(null);

  /** Bumped when user clicks Submit after extra payer fields (TransferMate). */
  const [tmPayerSubmitNonce, setTmPayerSubmitNonce] = useState(0);
  useEffect(() => {
    setTmPayerSubmitNonce(0);
    // Do not clear lastShopAutoCheckoutSig here: for countries with extra payer
    // steps (e.g. India) the auto payload stays the same base until Submit — clearing
    // the ref would re-post identical service_checkout on every country change.
  }, [countryCode, selectedPaymentMethod?.name]);

  /** All TransferMate fields including conversion method — Pay button. */
  const transferMateDetailsComplete = useMemo(() => {
    if (selectedPaymentMethod?.name !== "transfermate") return false;
    if (!paymentMethod || !transferMatePayerFieldsComplete) return false;
    return true;
  }, [
    selectedPaymentMethod?.name,
    paymentMethod,
    transferMatePayerFieldsComplete,
  ]);

  /** Auto service_checkout: never sends payment_method; TM init happens on Pay only. */
  const buildShopCheckoutPayloadForAuto = () => {
    const services = cartItems.map((item) => ({
      service_id: item.service_id,
      quantity: item.quantity,
      date: item.serviceDate
        ? dayjs(item.serviceDate).format("YYYY-MM-DD HH:mm")
        : null,
      size: item.selectedSize,
    }));
    const base = {
      student_id: student.student_id,
      services,
    };
    if (selectedPaymentMethod.name !== "transfermate") {
      return base;
    }
    if (!countryCode) {
      return base;
    }
    const payerStepDone =
      !needsTmExtraPayerFields ||
      (needsTmExtraPayerFields &&
        tmPayerSubmitNonce > 0 &&
        transferMatePayerFieldsComplete);
    if (!payerStepDone) {
      return base;
    }
    const canReuseShopTempInvoice =
      postPaymentDetails?.invoice_id != null &&
      shopInvoiceCartSig != null &&
      shopInvoiceCartSig === cartItemsSignature;
    return {
      ...base,
      country_code: countryCode,
      payer_document: payerDocument,
      student_chinese_name: chineseName,
      state: state,
      india_source_of_fund: indiaSourceOfFund,
      india_declaration_amt: indiaDeclarationAmt || null,
      ...(canReuseShopTempInvoice
        ? { checkout_invoice_id: postPaymentDetails.invoice_id }
        : {}),
    };
  };

  // useEffect(() => {
  //   console.log(cartItems, "cart items buada");
  // }, [cartItems]);
  const handleSetSelectedPaymentMethod = (paymentMethod) => {
    setSelectedPaymentMethod(paymentMethod);
  };

  // Derive available methods from checkout responses (invoice_checkout/service_checkout)
  const methodAliasMap = {
  };
  const rawAvailable = Array.isArray(postPaymentDetails?.available_methods)
    ? postPaymentDetails?.available_methods
    : Array.isArray(postPaymentDetails?.available_methods?.platforms)
      ? postPaymentDetails?.available_methods?.platforms
      : Array.isArray(postPaymentDetails?.payment?.available_methods)
        ? postPaymentDetails?.payment?.available_methods
        : Array.isArray(postPaymentDetails?.payment?.available_methods?.platforms)
          ? postPaymentDetails?.payment?.available_methods?.platforms
          : null;
  const availableMethodNames = rawAvailable
    ? rawAvailable
      .map((m) => String(m).trim().toLowerCase())
      .map((m) => methodAliasMap[m] ? methodAliasMap[m] : m)
    : null;

  // Keep selected method in sync with available methods
  useEffect(() => {
    if (availableMethodNames && availableMethodNames.length > 0) {
      const isCurrentAvailable = availableMethodNames.includes(
        selectedPaymentMethod?.name?.toLowerCase()
      );
      if (!isCurrentAvailable) {
        const firstAvailable = displayPaymentMethods.find((pm) =>
          availableMethodNames.includes(pm.name.toLowerCase())
        );
        if (firstAvailable) setSelectedPaymentMethod(firstAvailable);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postPaymentDetails]);

  useEffect(() => {
    if (!payrEnabled && selectedPaymentMethod?.name === "payr") {
      const fallback =
        displayPaymentMethods.find((pm) => pm.name === "transfermate") ||
        displayPaymentMethods[0];
      if (fallback) setSelectedPaymentMethod(fallback);
    }
  }, [payrEnabled, selectedPaymentMethod, displayPaymentMethods]);

  const handleGetPaymentId = async (invoiceId) => {
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    try {
      // GET isteği yapılacak URL
      const url = `${process.env.REACT_APP_BASE_URL}payments?invoice_id=${invoiceId}`;
      // Axios ile GET isteği yapılıyor

      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
          XRefreshToken: `${token}`, // Bearer token burada ekleniyor
          "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
        },
      });
      // Yanıtın içeriğini konsola yazdır
      setCartItems(response.data.payments);
    } catch (error) {
      // Hata durumunda hata mesajını konsola yazdır
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (invoiceId !== null && !postPaymentAirportTransfer) {
      handleGetPaymentId(invoiceId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceId]);

  useEffect(() => {
    if (bookingId !== null && postPaymentBookingDetails) {
      setPostPaymentDetails(postPaymentBookingDetails);
    }
  }, [bookingId, postPaymentBookingDetails]);

  useEffect(() => {
    if (invoiceId !== null && postPaymentAirportTransfer) {
      setPostPaymentDetails(postPaymentAirportTransfer?.payment);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceId, postPaymentAirportTransfer]);

  // useEffect(() => {
  //   console.log(postPaymentAirportTransfer, "postPaymentAirportTransfer");
  // }, [postPaymentAirportTransfer]);

  // useEffect(() => {
  //   if (postPaymentBookingDetails) {
  //     console.log(postPaymentDetails, "post payment details");
  //     console.log(postPaymentBookingDetails, "postPaymentBookingDetails");
  //     console.log(bookingId, "bookingId");
  //   }
  // }, [postPaymentDetails, postPaymentBookingDetails]);

  useEffect(() => {
    // Eğer invoiceId varsa ve paymentIds undefined veya boş bir array ise
    if (
      invoiceId &&
      !postPaymentAirportTransfer &&
      (!paymentIds || paymentIds.length === 0)
    ) {
      // Kullanıcıyı bir önceki sayfaya veya belirli bir sayfaya yönlendir
      navigate("/myinvoices"); // Bir önceki sayfaya dön
      // veya belirli bir sayfaya yönlendirme için navigate('/some/path');
    } else {
      setLoading(false); // paymentIds geçerliyse yükleme durumunu false yap
    }
  }, [invoiceId, paymentIds, navigate]);

  useEffect(() => {
    if (invoiceId == null && bookingId === null) {
      setCartItems(cartAdditionalServices);

      if (students.length) {
        dispatch(setStudent({}));
      } else {
        getStudents();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceId, bookingId, cartAdditionalServices]);

  const handlePostPayment = async (paymentIds, postPropsAdditional) => {
    setPaySnack(true);
    setLoadingBasket(true);
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");

    try {
      // GET isteği yapılacak URL
      let url;
      let data;

      if (postPropsAdditional) {
        if (!bookingId) {
          url = `${process.env.REACT_APP_BASE_URL}payment/service_checkout`;
          data = postPropsAdditional;
        } else if (bookingId) {
          if (selectedPaymentMethod.name === "transfermate") {
            url = `${process.env.REACT_APP_BASE_URL}booking/checkout`;
            data = {
              student: {
                firstname:
                  postPaymentDetails?.request_data?.student?.student_firstname,
                lastname:
                  postPaymentDetails?.request_data?.student?.student_lastname,
                phone: postPaymentDetails?.request_data?.student?.student_phone,
                email: postPaymentDetails?.request_data?.student?.student_email,
                nationality:
                  postPaymentDetails?.request_data?.student?.nationality,
                home_country:
                  postPaymentDetails?.request_data?.student?.home_country,
                form: {
                  source:
                    postPaymentDetails?.request_data?.student?.form?.source,
                  message:
                    postPaymentDetails?.request_data?.student?.form?.message,
                },
              },
              invoice: {
                course_id: postPaymentDetails?.request_data?.invoice?.course_id,
                checkin: postPaymentDetails?.request_data?.invoice?.checkin,
                checkout: postPaymentDetails?.request_data?.invoice?.checkout,
                campus_id: postPaymentDetails?.request_data?.invoice?.campus_id,
              },
              country_code: countryCode,
              payment_method: paymentMethod,
              payer_document: payerDocument,
              student_chinese_name: chineseName,
              state: state,
              india_source_of_fund: indiaSourceOfFund,
              india_declaration_amt:
                indiaDeclarationAmt !== "" && indiaDeclarationAmt != null
                  ? Number(indiaDeclarationAmt)
                  : null,
            };
          }
        }
      } else if (paymentIds) {
        url = `${process.env.REACT_APP_BASE_URL}payment/invoice_checkout`;
        if (selectedPaymentMethod.name === "transfermate") {
          if (!transferMatePayerFieldsComplete) {
            data = { payments_id: paymentIds };
          } else if (!paymentMethod) {
            data = {
              payments_id: paymentIds,
              country_code: countryCode,
              payer_document: payerDocument,
              student_chinese_name: chineseName,
              state: state,
              india_source_of_fund: indiaSourceOfFund,
              india_declaration_amt: indiaDeclarationAmt || null,
            };
          } else {
            data = {
              payments_id: paymentIds,
              country_code: countryCode,
              payment_method: paymentMethod,
              payer_document: payerDocument,
              student_chinese_name: chineseName,
              state: state,
              india_source_of_fund: indiaSourceOfFund,
              india_declaration_amt:
                indiaDeclarationAmt !== "" && indiaDeclarationAmt != null
                  ? Number(indiaDeclarationAmt)
                  : null,
            };
          }
        } else {
          data = { payments_id: paymentIds };
        }
      }
      // Axios ile GET isteği yapılıyor

      const response = await axiosInstance.post(url, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer token
          XRefreshToken: `${token}`, // XRefreshToken
          "Content-Type": "application/json", // Content-Type başlığı
        },
      });
      // Yanıtın içeriğini konsola yazdır
      if (response.message !== "documents_required") {
        setPostPaymentDetails(response.data);
        setPaySnack(false);
        setLoadingBasket(false);
      } else {
        setPaySnack(false);
        setLoadingBasket(false);
      }
      // else {
      //   //ALERT BURADA YAPILACAK VE YÖNLENDİRME OLACAK
      //   alert("Please upload passport and student letter.");
      //   setSelectedStudent({});
      //   dispatch(setStudent({}));
      //   setPaySnack(false);
      //   setLoadingBasket(false);
      //   // dispatch(
      //   //   showDialog(
      //   //     "Please upload passport and student letter.",
      //   //     "error",
      //   //     5,
      //   //     (!invoiceId ? "Shop" : "Invoices")
      //   //   )
      //   // );
      // }
    } catch (error) {
      if (error.response?.data?.code === "document_required") {
        // dispatch(
        //   openModal(
        //     <DocumentsRequiredModal data={error.response.data} />,
        //     "documentsRequired"
        //   )
        // );
      } else {
        // dispatch(
        //   openModal(<ErrorModal data={error.response.data} />, "selectStudent")
        // );
        setPaySnack(false);
      }
      setLoadingBasket(false);
      // Hata durumunda hata mesajını konsola yazdır
      console.error(error.response?.data?.code, "denemedir 123");

      console.error("Error fetching dataaa:", error);
    }
  };

  useEffect(() => {
    const path = location.pathname;
    if (
      path.includes("/payment/shop") ||
      path.includes("/payment/services") ||
      path.includes("/payment/airport-transfer")
    ) {
      setPaymentTypeServices(true);
    } else {
      setPaymentTypeServices(false);
    }
  }, [location]);

  useEffect(() => {
    if (invoiceId && paymentIds?.length) {
      handlePostPayment(paymentIds, null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceId, paymentIds, selectedPaymentMethod?.name]);

  /** After TransferMate payer step (country or Submit), refresh invoice checkout — not on every keystroke. */
  useEffect(() => {
    if (!invoiceId || !paymentIds?.length) return;
    if (selectedPaymentMethod?.name !== "transfermate") return;
    if (!transferMatePayerFieldsComplete) return;
    if (needsTmExtraPayerFields && tmPayerSubmitNonce === 0) return;
    handlePostPayment(paymentIds, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    invoiceId,
    paymentIds,
    selectedPaymentMethod?.name,
    transferMatePayerFieldsComplete,
    needsTmExtraPayerFields,
    tmPayerSubmitNonce,
  ]);

  useEffect(() => {
    if (!Object.keys(student).length) {
      setSelectedStudent({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student]);

  // useEffect(() => {
  //   console.log(selectedStudent, "selected student ehre..");
  // }, [selectedStudent]);

  useEffect(() => {
    if (!invoiceId && !bookingId) {
      if (Object.keys(student).length && cartItems.length) {
        const payload = buildShopCheckoutPayloadForAuto();
        const sig = JSON.stringify(payload);
        if (sig === lastShopAutoCheckoutSig.current) return;
        lastShopAutoCheckoutSig.current = sig;
        handlePostPayment(null, payload);
      } else {
        lastShopAutoCheckoutSig.current = null;
        setPostPaymentDetails(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    student?.student_id,
    cartItemsSignature,
    selectedPaymentMethod?.name,
    countryCode,
    needsTmExtraPayerFields,
    tmPayerSubmitNonce,
    postPaymentDetails?.invoice_id,
    shopInvoiceCartSig,
  ]);

  useEffect(() => {
    if (postPaymentDetails) {
      if (selectedPaymentMethod.name === "transfermate") {
        if (postPaymentDetails.transfermate?.result?.operation?.error_code) {
          let message =
            postPaymentDetails.transfermate?.result?.operation?.error_message;

          Swal.fire({
            icon: "error",
            title: message,
            showConfirmButton: false,
            showCloseButton: true,
          });
          setLoading(false);
        } else {
          const redirectUrl =
            postPaymentDetails?.transfermate?.result?.payment?.redirect_url;
          console.log("[redirect] decision", {
            redirectUrl,
            preOpened: Boolean(redirectWindowRef.current),
            willUsePreOpened: Boolean(
              redirectUrl && redirectWindowRef.current && !redirectWindowRef.current.closed
            ),
          });
          if (redirectUrl) {
            if (redirectWindowRef.current && !redirectWindowRef.current.closed) {
              try {
                redirectWindowRef.current.location = redirectUrl;
                console.log("[redirect] set pre-opened tab location");
              } catch (e) {
                console.error("[redirect] failed to set location on pre-opened tab", e);
                window.open(redirectUrl, "_blank");
              }
            } else if (!hasOpenedRedirect) {
              try {
                const win = window.open(redirectUrl, "_blank");
                console.log("[redirect] window.open result", win);
              } catch (e) {
                console.error("[redirect] window.open failed", e);
              }
            }
            setHasOpenedRedirect(true);
            redirectWindowRef.current = null;
          } else {
            // No redirect URL returned; close any pre-opened tab
            if (redirectWindowRef.current && !redirectWindowRef.current.closed) {
              try {
                redirectWindowRef.current.close();
                console.log("[redirect] closed pre-opened tab (no redirect_url)");
              } catch (e) {
                console.error("[redirect] failed to close pre-opened tab", e);
              }
            }
            redirectWindowRef.current = null;
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postPaymentDetails]);

  // useEffect(() => {
  //   if (cartItems.length && invoiceId) {
  //     let paymentIds = cartItems.map((cartItem) => cartItem.payment_id);
  //     setPaymentIds(paymentIds);
  //   }
  // }, [cartItems]);

  function payTransfermate() {
    let postPropsAdditional = null;

    if (!invoiceId && !paymentIds?.length) {
      postPropsAdditional = {
        student_id: student.student_id,
        services: cartItems.map((item) => ({
          service_id: item.service_id,
          quantity: item.quantity,
          date: item.serviceDate
            ? // dayjs(item.serviceDate).utc().local().format("YYYY-MM-DD HH:mm")
            dayjs(item.serviceDate).format("YYYY-MM-DD HH:mm")
            : null,
          size: item.selectedSize,
        })),
        country_code: countryCode,
        payment_method: paymentMethod,
        payer_document: payerDocument,
        student_chinese_name: chineseName,
        state: state,
        india_source_of_fund: indiaSourceOfFund,
        india_declaration_amt:
          indiaDeclarationAmt !== "" && indiaDeclarationAmt != null
            ? Number(indiaDeclarationAmt)
            : null,
      };
    } else if (invoiceId && !paymentIds?.length && postPaymentAirportTransfer) {
      postPropsAdditional = {
        student_id: postPaymentAirportTransfer.student_id,
        services: [postPaymentAirportTransfer.details],
        country_code: countryCode,
        payment_method: paymentMethod,
        payer_document: payerDocument,
        student_chinese_name: chineseName,
        state: state,
        india_source_of_fund: indiaSourceOfFund,
        india_declaration_amt:
          indiaDeclarationAmt !== "" && indiaDeclarationAmt != null
            ? Number(indiaDeclarationAmt)
            : null,
      };
    }

    // Pre-open a blank tab to avoid popup blockers; URL set on successful response
    try {
      redirectWindowRef.current = window.open("about:blank", "_blank");
      if (redirectWindowRef.current) {
        try {
          const preDoc = redirectWindowRef.current.document;
          preDoc.open();
          preDoc.write(
            '<!doctype html><html><head><meta charset="utf-8"><title>Redirecting…</title><meta name="viewport" content="width=device-width, initial-scale=1"><style>html,body{height:100%;margin:0}body{display:flex;align-items:center;justify-content:center;font-family:system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;background:#fff;color:#333}</style></head><body><div>Redirecting to secure payment…</div></body></html>'
          );
          preDoc.close();
        } catch (e) {
          console.warn("[payTransfermate] could not write pre-opened tab content", e);
        }
      }
      console.log("[payTransfermate] pre-opened tab", redirectWindowRef.current);
    } catch (e) {
      redirectWindowRef.current = null;
      console.error("[payTransfermate] pre-open failed", e);
    }
    handlePostPayment(paymentIds, postPropsAdditional);
  }

  function payFlywire() {
    // console.log(
    //   process.env.REACT_APP_PUBLIC_FLYWIRE_ENVIRONMENT,
    //   "Here is the ENVIRONMENT"
    // );
    if (!invoiceId && !bookingId && !Object.keys(student).length) {
      console.error("Hata: invoiceId gerekli");
      return;
    }

    // Extract gateway fee from the flywire method object
    const flywireData = postPaymentDetails?.flywire || {};
    const gw = flywireData?.gateway_fee || {};
    const platformFeeFixed = Number(gw?.fixed_amount ?? 0);
    const platformFeeRate = Number(gw?.rate_percent ?? 0);
    // If gateway_fee has fee_amount, use it; otherwise use platform_fee_amount
    const platformFeeTotal = Number(gw?.fee_amount ?? flywireData?.platform_fee_amount ?? 0);

    // Calculate the payment amount: for bookings include down payment + platform fee
    let paymentAmount = getCheckoutTotalWithFee(postPaymentDetails, "flywire");
    if (bookingId && postPaymentDetails) {
      const downPayment = Number(postPaymentDetails?.total_price || postPaymentDetails?.total_amount || 0);
      const platformFeeForBooking = Number(flywireData?.platform_fee_amount || 0);
      paymentAmount = downPayment + platformFeeForBooking;
    }

    var config = {
      env: process.env.REACT_APP_PUBLIC_FLYWIRE_ENVIRONMENT,
      nonce: postPaymentDetails.invoice_id
        ? `${postPaymentDetails?.invoice_id}--${postPaymentDetails?.flywire.include_deposit}`
        : postPaymentDetails.book_id
          ? `${postPaymentDetails?.book_id}`
          : null,
      amount: paymentAmount,
      platform_fee_fixed: platformFeeFixed,
      platform_fee_rate: platformFeeRate,
      platform_fee_total: platformFeeTotal,
      late_penalty_total: Number(postPaymentDetails?.late_penalty_total || 0),
      overdue_interest_total: Number(postPaymentDetails?.overdue_interest_total || 0),
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: "",
      city: "",
      country: "",
      recipientCode: "LTX",
      requestPayerInfo: true,
      recipientFields: {
        booking_reference: invoiceId
          ? invoiceId
          : bookingId
            ? bookingId
            : student.student_id,
        invoice_id: postPaymentDetails?.invoice_id,

        additional_information: postPaymentDetails?.flywire?.token,
      },
      paymentOptionsConfig: {
        // Only allow local card and online payments
        filters: {
          type: ["online", "credit_card"],
        },
      },

      // onCompleteCallback: (args) => {
      //   POST(API.Payment.Flywire.POST, {
      //     body: {
      //       ...args,
      //       services: cartItems.map((item) => ({
      //         service_id: item.service_id,
      //         quantity: item.quantity,
      //         date: item.serviceDate
      //           ? // dayjs(item.serviceDate).utc().local().format("YYYY-MM-DD HH:mm")
      //             dayjs(item.serviceDate).format("YYYY-MM-DD HH:mm")
      //           : null,
      //         size: item.selectedSize,
      //       })),
      //       // invoice_payments_id: paymentsId || [],
      //       // invoice_id: isInvoice ? invoiceId : invoice_id,
      //       // vat: 0,
      //     },
      //   })
      //     .then((res) => {
      //     })
      //     .catch((err) => {

      //     })
      //     .finally(() => {
      //     });
      // },

      onCompleteCallback: async (args) => {
        let services;
        let studentId;
        if (postPaymentAirportTransfer) {
          services = [postPaymentAirportTransfer.details];
          studentId = postPaymentAirportTransfer?.student_id;
        } else {
          services = cartItems.map((item) => ({
            service_id: item.service_id,
            quantity: item.quantity,
            date: item.serviceDate
              ? dayjs(item.serviceDate).format("YYYY-MM-DD HH:mm")
              : null,
            size: item.selectedSize,
          }));
          studentId = student.student_id;
        }
        // const services = cartItems.map((item) => ({
        //   service_id: item.service_id,
        //   quantity: item.quantity,
        //   date: item.serviceDate
        //     ? dayjs(item.serviceDate).format("YYYY-MM-DD HH:mm")
        //     : null,
        //   size: item.selectedSize,
        // }));

        const queryParams = new URLSearchParams({
          ...args,
          services: !paymentTypeServices ? null : JSON.stringify(services),
          student_id: studentId,
          platform_fee_fixed: platformFeeFixed,
          platform_fee_rate: platformFeeRate,
          platform_fee_total: platformFeeTotal,
          late_penalty_total: Number(postPaymentDetails?.late_penalty_total || 0),
      overdue_interest_total: Number(postPaymentDetails?.overdue_interest_total || 0),
          // invoice_payments_id: paymentsId || [],
          // invoice_id: isInvoice ? invoiceId : invoice_id,
          // vat: 0,
        });

        let url = bookingId
          ? `${process.env.REACT_APP_BASE_URL}payment/flywire/instant_booking/callback`
          : `${process.env.REACT_APP_BASE_URL}payment/flywire/callback`;
        let accessToken = localStorage.getItem("accessToken");
        let token = localStorage.getItem("loginUser");
        try {
          const response = await axiosInstance.get(
            `${url}?${queryParams.toString()}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
                XRefreshToken: `${token}`, // Bearer token burada ekleniyor
                "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
              },
            }
          );
          if (response?.data?.redirect_url) {
            window.location.href = response?.data?.redirect_url;
          }
          // navigate(`/${response?.data?.redirect_url}`);
        } catch (error) {
          console.error("API isteği sırasında hata oluştu:", error);
        }

        // POST(`${url}?${queryParams.toString()}`)
        //   .then((res) => {})
        //   .catch((err) => {})
        //   .finally(() => {});
      },

      returnUrl: `${postPaymentDetails?.flywire?.callback_url}`,
      callbackUrl: `${postPaymentDetails?.flywire?.notification_url}`,
      callbackVersion: "2",
    };
    var modal = window.FlywirePayment.initiate(config);
    modal.render();
  }
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin

  if (loading) {
    // Burada bir yükleme göstergesi veya null döndürebilirsiniz
    return null; // veya <LoadingIndicator />
  }

  if (bookingId && !postPaymentBookingDetails) {
    navigate("/room-finder");
    return null;
  }
  return (
    <>
      <Typography textTransform={"capitalize"} className="title" variant="h4">
        {t("payment")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("payment")]} />
      <Grid container spacing={5} sx={{ marginTop: "1rem" }}>
        <Grid item xs={12} lg={8}>
          <Box
            sx={{
              height: "100%",
              backgroundColor: lightMode ? "#FCFCFC" : "#282828",
              filter: "drop-shadow(0px 3px 6px #00000029)",
              padding: { xs: "1rem", lg: "2rem" },
              display: "flex",
              flexDirection: "column",
              borderRadius: "1rem",
            }}
          >
            {!invoiceId && !bookingId ? (
              <Box sx={{ marginBottom: "1rem" }}>
                <Typography
                  sx={{
                    fontSize: "24px",
                    borderBottom: "1px solid #e6e6e6",
                    paddingBottom: ".5rem",
                    marginBottom: "2rem",
                    textTransform: 'capitalize'
                  }}
                >
                  {t("selectStudent")}
                </Typography>

                <Box>
                  {/* <FormControl
                    disabled={!students.length}
                    sx={{ minWidth: "200px" }}
                  >
                    <InputLabel id="select-student">Select Student</InputLabel>
                    <Select
                      labelId="select-student"
                      id="select-student"
                      value={
                        !Object.keys(student).length
                          ? "Select Student"
                          : selectedStudent
                      }
                      label="Select Student"
                      onChange={handleStudent}
                    >
                      <MenuItem
                        sx={{ display: "none" }}
                        value={"Select Student"}
                      >
                        Select Student
                      </MenuItem>
                      {students?.map((student, idx) => {
                        return (
                          <MenuItem
                            //disabled={student?.student_id !== 8107}
                            key={student?.student_id}
                            value={student}
                          >
                            {student?.student_name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl> */}
                  <SelectStudent
                    students={students}
                    paySnack={paySnack}
                    handleStudent={handleStudent}
                    selectedStudent={student}
                  />
                </Box>
              </Box>
            ) : null}

            <Typography
              sx={{
                fontSize: "24px",
                borderBottom: "1px solid #e6e6e6",
                paddingBottom: ".5rem",
                marginBottom: "2rem",
                textTransform: 'capitalize'
              }}
            >
              {t("selectYourPaymentMethod")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                flexWrap: { xs: "nowrap", md: "wrap" },
                rowGap: { md: "1rem" },
              }}
            >
              {(availableMethodNames && availableMethodNames.length
                ? displayPaymentMethods.filter((pm) =>
                  availableMethodNames.includes(pm.name.toLowerCase())
                )
                : displayPaymentMethods)
                .filter((paymentMethod) =>
                  bookingId
                    ? paymentMethod.name !== "easytransfer"
                    : // &&
                    //   paymentMethod.name !== "transfermate"
                    true
                )
                .map((paymentMethod, idx) => {
                  return (
                    <>
                      {!postPaymentDetails && paymentType === "invoice" ? (
                        <Skeleton
                          sx={{
                            borderRadius: "1rem",

                            width: "150px",
                            height: "150px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            filter: `drop-shadow(0px 3px 6px ${selectedPaymentMethod.name === paymentMethod.name
                              ? "black"
                              : "#00000029"
                              })`,
                            marginRight: {
                              xs: "0",
                              md:
                                displayPaymentMethods.length !== idx + 1
                                  ? "2rem"
                                  : "0",
                            },
                          }}
                          variant="rectangular"
                        />
                      ) : (
                        <Box
                          onClick={() =>
                            handleSetSelectedPaymentMethod(paymentMethod)
                          }
                          sx={{
                            borderRadius: "1rem",
                            backgroundColor:
                              selectedPaymentMethod.name === paymentMethod.name
                                ? "#23416c"
                                : "#ffffff",
                            width: "150px",
                            height: "150px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            filter: `drop-shadow(0px 3px 6px ${selectedPaymentMethod.name === paymentMethod.name
                              ? "black"
                              : "#00000029"
                              })`,
                            marginBottom: { xs: "1rem", md: "0" },

                            marginRight: {
                              xs: "0",
                              md:
                                displayPaymentMethods.length !== idx + 1
                                  ? "2rem"
                                  : "0",
                            },
                          }}
                        >
                          <img
                            alt={paymentMethod.name || ""}
                            width={paymentMethod.name === "bank_transfer" ? 140 : 110}
                            height={paymentMethod.name === "bank_transfer" ? 140 : 110}
                            src={
                              selectedPaymentMethod.name === paymentMethod.name
                                ? paymentMethod.img
                                : paymentMethod.imgLight
                            }
                            style={{
                              objectFit: "contain",
                              objectPosition: "center",
                              filter:
                                paymentMethod.name === "payr" &&
                                selectedPaymentMethod.name === paymentMethod.name
                                  ? "invert(1) hue-rotate(180deg)"
                                  : "none",
                            }}
                          />
                        </Box>
                      )}
                    </>
                  );
                })}
            </Box>
            {(() => {
              const methodKey = selectedPaymentMethod?.name?.toLowerCase();
              const gatewayFee = postPaymentDetails?.[methodKey]?.gateway_fee;
              const feeAmount = Number(gatewayFee?.fee_amount || 0);
              const hasFee = gatewayFee && (feeAmount > 0 || Number(gatewayFee?.fixed_amount || 0) > 0 || Number(gatewayFee?.rate_percent || 0) > 0);
              const isFlywire = selectedPaymentMethod?.name?.toLowerCase() === "flywire";
              const platformFeeAmount = postPaymentDetails?.flywire?.platform_fee_amount;

              return (
                <>
                  {hasFee ? (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        marginTop: "1rem",
                        color: "#8a6d3b",
                        background: "#fcf8e3",
                        border: "1px solid #faebcc",
                        borderRadius: ".5rem",
                        padding: ".75rem 1rem",
                      }}
                    >
                      A platform fee will be applied for {selectedPaymentMethod?.name} at checkout.
                    </Typography>
                  ) : null}
                  {isFlywire && platformFeeAmount && Number(platformFeeAmount) > 0 ? (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        marginTop: "1rem",
                        color: "#8a6d3b",
                        background: "#fcf8e3",
                        border: "1px solid #faebcc",
                        borderRadius: ".5rem",
                        padding: ".75rem 1rem",
                      }}
                    >
                      Heads up: a platform fee of £{Number(platformFeeAmount).toFixed(2)} will be added to your total when paying with flywire.
                    </Typography>
                  ) : null}
                </>
              );
            })()}
            {selectedPaymentMethod?.name === "transfermate" ? (
              <Box
                sx={{
                  marginTop: { xs: "1.5rem", lg: "3rem" },
                }}
              >
                {/* <TransferMate /> */}
                <TransferMate
                  totalPrice={
                    getCheckoutTotalWithFee(postPaymentDetails, "transfermate") ||
                    totalPrice
                  }
                  countriesInit={countriesInit}
                  setPaymentMethod={setPaymentMethod}
                  setCountryCode={setCountryCode}
                  setPayerDocument={setPayerDocument}
                  setState={setState}
                  identificationControl={identificationControl}
                  setIdentificationControl={setIdentificationControl}
                  stateCodeControl={stateCodeControl}
                  setStateCodeControl={setStateCodeControl}
                  chineseNameControl={chineseNameControl}
                  setChineseNameControl={setChineseNameControl}
                  setChineseName={setChineseName}
                  indiaSourceOfFund={indiaSourceOfFund}
                  setIndiaSourceOfFund={setIndiaSourceOfFund}
                  indiaDeclarationAmt={indiaDeclarationAmt}
                  setIndiaDeclarationAmt={setIndiaDeclarationAmt}
                  selectedStudent={Object.keys(student).length}
                  paymentType={paymentType}
                  needsExtraPayerFields={needsTmExtraPayerFields}
                  payerFieldsComplete={transferMatePayerFieldsComplete}
                  onPayerStepSubmitted={() =>
                    setTmPayerSubmitNonce((n) => n + 1)
                  }
                />
              </Box>
            ) : selectedPaymentMethod?.name === "bank_transfer" ? (
              <Box sx={{ marginTop: { xs: "1.5rem", lg: "3rem" } }}>
                <BankTransfer />
              </Box>
            ) : selectedPaymentMethod?.name === "payr" ? (
              <Box sx={{ marginTop: { xs: "1.5rem", lg: "3rem" } }}>
                <PayrPayment
                  payrData={postPaymentDetails?.payr}
                  onPayrUpdate={(next) =>
                    setPostPaymentDetails((prev) => ({ ...(prev || {}), payr: next }))
                  }
                />
              </Box>
            ) : (
              <Typography
                sx={{
                  fontSize: "18px",

                  marginTop: { xs: "1.5rem", lg: "3rem" },
                }}
              >
                To completing your payment with{" "}
                <strong style={{ textTransform: "capitalize" }}>
                  {selectedPaymentMethod.name}{" "}
                </strong>
                payment method click to pay and completed the payment form
              </Typography>
            )}

            <Button
                onClick={() => {
                  if (selectedPaymentMethod.name === "flywire") payFlywire();
                  if (
                    selectedPaymentMethod?.name === "easytransfer" &&
                    !postPaymentDetails?.easytransfer?.url
                  ) {
                    Swal.fire({
                      icon: "error",
                      title: "Country Not Supported!",
                      showConfirmButton: false,
                      showCloseButton: true,
                    });
                  }
                  if (selectedPaymentMethod.name === "transfermate") payTransfermate();
                  if (selectedPaymentMethod.name === "payr") {
                    const iframeUrl = postPaymentDetails?.payr?.iframe_url;
                    if (iframeUrl) {
                      dispatch(
                        openModal(
                          <PayrIframeModal data={{ iframeUrl }} />,
                          "payrIframe"
                        )
                      );
                    }
                  }
                }}

                href={`${selectedPaymentMethod.name === "easytransfer"
                  ? postPaymentDetails?.easytransfer?.url
                    ? postPaymentDetails?.easytransfer?.url
                    : postPaymentDetails?.easytransfer?.pay_url
                      ? postPaymentDetails?.easytransfer?.pay_url
                      : ""
                  : ""
                  }`}
                variant="contained"
                color="primary"
                startIcon={
                  paySnack ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : null
                }
                disabled={
                  paySnack ||
                  (paymentType !== "invoice" &&
                    paymentType !== "booking" &&
                    !Object.keys(student).length) ||
                  (selectedPaymentMethod.name !== "transfermate" &&
                    !postPaymentDetails) ||
                  (Number(
                    getCheckoutTotalWithFee(
                      postPaymentDetails,
                      selectedPaymentMethod?.name
                    )
                  ) === 0) ||
                  // (selectedPaymentMethod.name === "easytransfer" &&
                  //   !postPaymentDetails?.easytransfer?.url) ||
                  (selectedPaymentMethod.name === "transfermate" &&
                    !transferMateDetailsComplete) ||
                  (selectedPaymentMethod.name === "payr" &&
                    !postPaymentDetails?.payr?.iframe_url) ||
                  selectedPaymentMethod.name === "bank_transfer"
                }
                sx={{ textTransform: 'capitalize', marginLeft: "auto", marginTop: "1rem" }}
              >
                {t("payNow")}
              </Button>
          </Box>
        </Grid>
        <Grid item xs={12} lg={4}>
          {invoiceId !== null ? (
            postPaymentDetails ? (
              postPaymentAirportTransfer ? (
                <Basket
                  invoiceId={invoiceId}
                  totalPrice={totalPrice}
                  setTotalPrice={setTotalPrice}
                  cartItems={postPaymentAirportTransfer}
                  selectedPaymentMethodName={selectedPaymentMethod?.name}
                />
              ) : (
                <Basket
                  invoiceId={invoiceId}
                  cartItems={postPaymentDetails}
                  totalPrice={totalPrice}
                  setTotalPrice={setTotalPrice}
                  selectedPaymentMethodName={selectedPaymentMethod?.name}
                />
              )
            ) : (
              <Basket
                invoiceId={invoiceId}
                totalPrice={totalPrice}
                setTotalPrice={setTotalPrice}
                cartItems={[]}
                loading={loadingBasket}
                selectedPaymentMethodName={selectedPaymentMethod?.name}
              />
            )
          ) : bookingId !== null ? (
            postPaymentDetails ? (
              <Basket
                bookingId={bookingId}
                cartItems={postPaymentDetails}
                totalPrice={totalPrice}
                setTotalPrice={setTotalPrice}
                selectedPaymentMethodName={selectedPaymentMethod?.name}
              />
            ) : (
              <Basket
                bookingId={bookingId}
                totalPrice={totalPrice}
                setTotalPrice={setTotalPrice}
                cartItems={[]}
                loading={loadingBasket}
                selectedPaymentMethodName={selectedPaymentMethod?.name}
              />
            )
          ) : (
            <Basket
              cartItems={postPaymentDetails || cartItems}
              paymentType={paymentType}
              totalPrice={totalPrice}
              setTotalPrice={setTotalPrice}
              selectedPaymentMethodName={selectedPaymentMethod?.name}
              cartItemsList={cartItems}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}
